<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="#28a745">mdi-file</v-icon>
          <h4>{{ $t("messages.general.showInfo") }}</h4>
        </div>
        <div class="card-body">
          <div>
            <div class="information-block">
              <div class="row">
                <div class="col no-padding-bottom">
                  <div class="information-detail">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <div>{{ $t("messages.general.identity") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ appInfo.data.USERCODE_TXT }}</div>
                    </div>
                  </div>
                </div>
                <div class="col no-padding-bottom">
                  <div class="information-detail">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <div>{{ $t("messages.general.fullname") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ appInfo.data.USERNAME }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col no-padding-bottom">
                  <div class="information-detail">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <div>{{ $t("messages.general.academicYear") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ appInfo.data.CURRENT_ACADYEAR }}</div>
                    </div>
                  </div>
                </div>
                <div class="col no-padding-bottom">
                  <div class="information-detail">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <div>{{ $t("messages.general.semester") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ appInfo.data.CURRENT_SEMESTER }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="appInfo.data.ISSHOW_PRINTINVOICEBUTTON == 'Y'"
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    v-if="showPrint"
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleClickQr()"
                  >
                    {{ $t("messages.general.qrcodeMobileBank") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    v-if="showPrint"
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleClickPrint()"
                  >
                    {{ $t("messages.checkRegResult.printStatementPayment") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <v-tabs>
            <v-tab>{{ $t("messages.general.timeTable") }}</v-tab>
            <v-tab>{{ $t("messages.general.examTimeTable") }}</v-tab>
            <v-tab>{{ $t("messages.general.registerFee") }}</v-tab>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-sheet height="64">
                    <v-toolbar flat color="white">
                      <v-btn outlined class="mr-4" @click="setToday">
                        {{ $t("messages.general.today") }}
                      </v-btn>
                      {{ prevDateRange }}
                      <v-btn fab text small @click="prev">
                        <v-icon small>mdi-chevron-left</v-icon>
                      </v-btn>
                      <v-btn fab text small @click="next">
                        <v-icon small>mdi-chevron-right</v-icon>
                      </v-btn>
                      {{ nextDateRange }}
                      <div class="flex-grow-1"></div>
                    </v-toolbar>
                  </v-sheet>
                  <v-sheet>
                    <v-calendar
                      ref="calendar"
                      v-model="focus"
                      type="week"
                      :color="color"
                      :events="events"
                      :event-color="eventColor"
                      :first-interval="intervals.first"
                      :interval-minutes="intervals.minutes"
                      :interval-count="intervals.count"
                      :interval-height="intervals.height"
                      :weekdays="weekDays"
                      :locale="locale"
                      :interval-format="intervalFormatter"
                      :weekday-format="weekdayFormatter"
                      :day-format="dayFormatter"
                      :event-name="getEventName"
                      @click:event="showEvent"
                    >
                    </v-calendar>
                  </v-sheet>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-card>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-center">
                              {{ $t("messages.general.seqOrder") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.classId") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.className") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.credit") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.examMidTermDate") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.examFinalTermDate") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in examData" :key="index">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td class="text-center">
                              {{ item.COURSECODE }}
                            </td>
                            <td>{{ item.COURSENAME }}</td>
                            <td
                              class="text-center"
                              style="white-space: nowrap !important"
                            >
                              {{ item.COURSEUNIT }}
                            </td>
                            <td class="text-center">
                              {{ item.EXAM_MIDTERM_DATE }}
                            </td>
                            <td class="text-center">
                              {{ item.EXAM_FINAL_DATE }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-card>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-center">
                              {{ $t("messages.general.seqOrder") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.feeList") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.registationFee") }}
                            </th>
                            <!-- <th class="text-center">
                              {{ $t("messages.general.overdueAmout") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.receiveCashBack") }}
                            </th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in financeData" :key="index">
                            <td class="text-center">
                              {{ item.SEQ }}
                            </td>
                            <td>
                              {{ item.FEEIDNAME }}
                            </td>
                            <td class="text-right">
                              {{
                                isNaN(item.BALANCE) ||
                                item.BALANCE == null ||
                                item.BALANCE == 0 ||
                                item.BALANCE == ""
                                  ? ""
                                  : numberFormat(item.BALANCE)
                              }}
                            </td>
                            <!-- <td class="text-right">
                              {{ numberFormat(item.BALANCE) }}
                            </td>
                            <td class="text-right">
                              {{ numberFormat(item.AMOUNT - item.BALANCE) }}
                            </td> -->
                          </tr>
                        </tbody>
                        <tfoot>
                          <td class="text-center"></td>
                          <td class="text-right">
                            {{ $t("messages.general.netTotal") }}
                          </td>
                          <!-- <td class="text-right"></td> -->
                          <td class="text-right">
                            {{ numberFormat(financeFooterData.total) }}
                          </td>
                          <!-- <td class="text-right">
                            {{ numberFormat(financeFooterData.totalBack) }}
                          </td> -->
                        </tfoot>
                      </table>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>

          <v-dialog v-model="dialogError" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="red darken-3">
                <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
                <v-toolbar-title style="color: #ffebee;"
                  >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogError = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="red accent-1">
                <br />
                <span style="color: red;" v-html="errorText">{{
                  errorText
                }}</span>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogQrCode" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>fa-info</v-icon>
                <v-toolbar-title
                  >&nbsp;{{
                    $t("messages.general.qrcodeMobileBank")
                  }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogQrCode = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text class="text-center">
                <div style="width: 99%; margin: 0 auto">
                  <p style="font-size: medium;">
                    {{ $t("messages.general.qrMobileTitle") }}
                  </p>
                  <a :href="qrLink" :download="qrFileName">
                    <img style="width: 200px" :src="dialogQrSrc" />
                  </a>
                  <p
                    style="font-size: medium; margin-top: 15px; margin-bottom: 0 !important"
                  >
                    {{ $t("messages.general.qrMoblieReason") }}
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color">
                <v-toolbar-title
                  v-html="selectedEvent.name"
                  style="color: #fff !important"
                ></v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <span>{{ selectedEvent.section }}</span
                ><br />
                <span>{{ selectedEvent.building }}</span
                ><br />
                <span
                  >{{ selectedEvent.starttime }} -
                  {{ selectedEvent.endtime }}</span
                >
              </v-card-text>
              <v-card-actions>
                <v-btn text color="secondary" @click="selectedOpen = false">
                  {{ $t("messages.general.close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <iframe
            v-if="isVisible"
            :src="pdf"
            class="w-100"
            height="900"
          ></iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import "moment/locale/th";

import ClassProvider from "@/services/class_provider";
import ReportProvider from "@/services/report_provider";

const classProvider = new ClassProvider();
const reportProvider = new ReportProvider();

export default {
  name: "chkRegisterResult",
  data() {
    return {
      focus: new Date(),
      today: new Date(),
      locale: "th",
      color: "pink",
      eventColor: "#0bbbec",
      intervals: {
        first: 7,
        minutes: 60,
        count: 14,
        height: 30
      },
      shortIntervals: false,
      shortWeekdays: false,
      selected: 0,
      detail: 0,
      weekDays: [1, 2, 3, 4, 5, 6, 0],
      prevDateRange: "",
      nextDateRange: "",
      prevDateFirst: new Date(),
      nextDateFirst: new Date(),
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      currentDateRange: {
        firstDate: new Date(),
        lastDate: new Date()
      },
      events: [],
      examData: [],
      financeData: [],
      financeFooterData: {},
      numberFormatOpt: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      dialogErrorTitle: "",
      dialogError: false,
      errorText: "",
      dialogQrCode: false,
      dialogQrSrc: "",
      qrLink: "",
      qrFileName: "qrCode.png",
      isVisible: false,
      pdf: "",
      showPrint: false
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      studentInfo: "getStudentInfo",
      studentId: "getStudentId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    currentUserId: function() {
      return _.isEmpty(this.studentInfo.data) ? this.userId : this.studentId;
    }
  },
  async mounted() {
    this.tokenHealthChk();
    this.loadData();
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    async loadData() {
      this.togglePreLoader(true);
      const payload = {
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          studentid: this.currentUserId,
          lang: this.currentLang
        }
      };
      await this.getClassTime(this.today, true);
      this.examData = await classProvider.getExamTime(payload);
      this.financeData = await classProvider.getFinance(payload);
      this.financeFooterData.total = 0;
      this.financeFooterData.totalBack = 0;
      if (this.financeData != undefined) {
        for (let i = 0; i < this.financeData.length; i++) {
          this.financeFooterData.total +=
            isNaN(this.financeData[i].BALANCE) ||
            this.financeData[i].BALANCE == null ||
            this.financeData[i].BALANCE == ""
              ? 0
              : this.financeData[i].BALANCE;
        }
      }
      if (this.financeFooterData.total > 0) {
        this.showPrint = true;
      }
      if (this.$refs.calendar != undefined) {
        this.$refs.calendar.scrollToTime("07:00");
      }
      this.togglePreLoader(false);
    },
    intervalFormatter(interval) {
      const arrTime = interval.time.split(":");
      const sh = arrTime[0];
      // const eh = parseInt(sh) + 1;
      // const pad = "00";
      if (sh > 20) return "";
      // return `${pad.substring(0, pad.length - sh.toString().length) + sh.toString()}:00 - ${pad.substring(0, pad.length - eh.toString().length) + eh.toString()}:00`;
      return interval.time;
    },
    weekdayFormatter(e) {
      return moment(e.date)
        .locale(this.currentLang)
        .format("dddd");
    },
    dayFormatter(e) {
      const year = moment(e.date)
        .locale(this.currentLang)
        .format("YYYY");
      return `${moment(e.date)
        .locale("th")
        .format("DD MMMM")} ${this.getYearText(year)}`;
    },
    getEventName(e) {
      return `<div style="white-space: normal;">${e.input.name}<div>`;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    async setToday() {
      this.getPrevNextDateRange(this.today);
      await this.getClassTime(this.today);
      this.focus = this.today;
    },
    async setFocusDate(d) {
      const dt = new Date(d);
      this.togglePreLoader(true);
      this.focus = moment(dt).format("YYYY-MM-DD");
      this.getCurrentDateRange(dt);
      this.getPrevNextDateRange(dt);
      this.togglePreLoader(false);
    },
    async prev() {
      this.togglePreLoader(true);
      this.getPrevNextDateRange(this.prevDateFirst);
      await this.getClassTime(
        this.getSundayForPrevRange(this.currentDateRange.firstDate)
      );
      this.togglePreLoader(false);
      this.$refs.calendar.prev();
    },
    async next() {
      this.togglePreLoader(true);
      this.getPrevNextDateRange(this.nextDateFirst);
      await this.getClassTime(
        this.getMondayForNextRange(this.currentDateRange.lastDate)
      );
      this.togglePreLoader(false);
      this.$refs.calendar.next();
    },
    getYearText(year) {
      return this.currentLang == "th" ? `${parseInt(year) + 543}` : `${year}`;
    },
    getSundayForPrevRange(d) {
      return d.setDate(d.getDate() - 1);
    },
    getMondayForNextRange(d) {
      return d.setDate(d.getDate() + 1);
    },
    getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },
    getCurrentDateRange(d) {
      this.currentDateRange.firstDate = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate())
      );
      this.currentDateRange.lastDate = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() + 6)
      );
      return {
        first: `${moment(this.currentDateRange.firstDate).format(
          "MM/DD/YYYY"
        )}`,
        last: `${moment(this.currentDateRange.lastDate).format("MM/DD/YYYY")}`
      };
    },
    getPrevNextDateRange(d) {
      d = new Date(d);
      const prevDateRangeFirstD = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() - 7)
      );
      this.prevDateFirst = prevDateRangeFirstD;
      const prevDateRangeLastD = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() - 1)
      );
      const nextDateRangeFirstD = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() + 7)
      );
      this.nextDateFirst = nextDateRangeFirstD;
      const nextDateRangeLastD = new Date(
        this.getMonday(d).setDate(this.getMonday(d).getDate() + 13)
      );
      this.prevDateRange = `${moment(prevDateRangeFirstD)
        .locale(this.currentLang)
        .format("DD MMMM")} ${this.getYearText(
        prevDateRangeFirstD.getFullYear()
      )} - ${moment(prevDateRangeLastD)
        .locale(this.currentLang)
        .format("DD MMMM")} ${this.getYearText(
        prevDateRangeLastD.getFullYear()
      )}`;
      this.nextDateRange = `${moment(nextDateRangeFirstD)
        .locale(this.currentLang)
        .format("DD MMMM")} ${this.getYearText(
        nextDateRangeFirstD.getFullYear()
      )} - ${moment(nextDateRangeLastD)
        .locale(this.currentLang)
        .format("DD MMMM")} ${this.getYearText(
        nextDateRangeLastD.getFullYear()
      )}`;
    },
    getDateFromWeekDay(weekday) {
      const d = new Date(this.currentDateRange.firstDate);
      let dayToAdd = 0;
      switch (weekday) {
        case "Monday":
          dayToAdd = 0;
          break;
        case "Tuesday":
          dayToAdd = 1;
          break;
        case "Wednesday":
          dayToAdd = 2;
          break;
        case "Thursday":
          dayToAdd = 3;
          break;
        case "Friday":
          dayToAdd = 4;
          break;
        case "Saturday":
          dayToAdd = 5;
          break;
        case "Sunday":
          dayToAdd = 6;
          break;
      }
      return d.setDate(d.getDate() + dayToAdd);
    },
    initTimetable(data) {
      const d = this.getDateFromWeekDay(data.WEEKDAY);
      return {
        name: `${data.COURSECODE}-${data.COURSENAME}`,
        section: data.SECTION_TEXT,
        building: data.BUILDINGNAME,
        start: `${moment(d).format("YYYY-MM-DD")} ${data.TIMEFROM}`,
        end: `${moment(d).format("YYYY-MM-DD")} ${data.TIMETO}`,
        starttime: data.TIMEFROM,
        endtime: data.TIMETO,
        color: this.eventColor
      };
    },
    async getClassTime(d, ignoreDate = false) {
      const curretDateRangeTxt = ignoreDate ? {} : this.getCurrentDateRange(d);
      const classTime = await classProvider.getClassTime({
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          studentid: this.currentUserId,
          firstdate: ignoreDate ? "11/11/1111" : curretDateRangeTxt.first,
          lastdate: ignoreDate ? "11/11/1111" : curretDateRangeTxt.last,
          lang: this.currentLang
        }
      });
      const tmpEvent = [];
      let isFirst = true;
      classTime.forEach(c => {
        if (isFirst && ignoreDate) {
          isFirst = false;
          this.setFocusDate(moment(c.OPEN_DATE).toDate());
        }
        tmpEvent.push(this.initTimetable(c));
      });
      if (tmpEvent.length == 0 && ignoreDate) {
        await this.setToday();
      }
      this.events = tmpEvent;
    },
    numberFormat(num) {
      return Number(num).toLocaleString(this.currentLang, this.numberFormatOpt);
    },
    async handleClickPrint() {
      this.togglePreLoader(true);
      const res = await reportProvider.getReportB1({
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          studentid: this.currentUserId,
          lang: this.currentLang
        }
      });
      if (res.status == 200) {
        this.isVisible = false;
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        // window.open(
        //   "web/viewer.html?file=" +
        //     encodeURIComponent(fileURL) +
        //     "&filename=" +
        //     encodeURIComponent("B1.pdf") +
        //     "&_=" +
        //     new Date().getTime()
        // );
        const e = document.createEvent("MouseEvents");
        const a = document.createElement("a");
        a.download = `invoice_${this.appInfo.data.USERCODE}.pdf`;
        a.href = fileURL;
        a.dataset.downloadurl = ["application/pdf", a.download, a.href].join(
          ":"
        );
        e.initEvent(
          "click",
          true,
          false,
          window,
          0,
          0,
          0,
          0,
          0,
          false,
          false,
          false,
          false,
          0,
          null
        );
        a.dispatchEvent(e);
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = this.$t("messages.checkRegResult.printError");
      }
      this.togglePreLoader(false);
    },
    toDataURL(url) {
      return fetch(url)
        .then(response => {
          return response.blob();
        })
        .then(blob => {
          return URL.createObjectURL(blob);
        });
    },
    async handleClickQr() {
      this.togglePreLoader(true);
      const res = await classProvider.genqrcode({
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          studentid: this.currentUserId,
          lang: this.currentLang
        }
      });
      if (res.status == 200) {
        const file = new Blob([res.data], { type: "image/png" });
        this.dialogQrSrc = URL.createObjectURL(file);
        this.qrLink = URL.createObjectURL(file);
        this.dialogQrCode = true;
      }
      this.togglePreLoader(false);
    }
  },
  watch: {
    currentLang() {
      this.loadData();
    }
  }
};
</script>
